import { addUnit as g } from "../utils/style.js";
import { onMounted as W, watchEffect as B, onBeforeUnmount as U } from "vue";
const C = (t, e, p) => {
  let c = {
    offsetX: 0,
    offsetY: 0
  };
  const m = (u) => {
    const L = u.clientX, M = u.clientY, { offsetX: n, offsetY: s } = c, o = t.value.getBoundingClientRect(), a = o.left, l = o.top, w = o.width, X = o.height, Y = document.documentElement.clientWidth, x = document.documentElement.clientHeight, b = -a + n, D = -l + s, H = Y - a - w + n, T = x - l - X + s, d = (f) => {
      const r = Math.min(
        Math.max(n + f.clientX - L, b),
        H
      ), h = Math.min(
        Math.max(s + f.clientY - M, D),
        T
      );
      c = {
        offsetX: r,
        offsetY: h
      }, t.value.style.transform = `translate(${g(
        r
      )}, ${g(h)})`;
    }, v = () => {
      document.removeEventListener("mousemove", d), document.removeEventListener("mouseup", v);
    };
    document.addEventListener("mousemove", d), document.addEventListener("mouseup", v);
  }, E = () => {
    e.value && t.value && e.value.addEventListener("mousedown", m);
  }, i = () => {
    e.value && t.value && e.value.removeEventListener("mousedown", m);
  };
  W(() => {
    B(() => {
      p.value ? E() : i();
    });
  }), U(() => {
    i();
  });
};
export {
  C as useDraggable
};
